import { Box, Button, HStack, Image, Stack } from '@chakra-ui/react';
import { LuDownload } from 'react-icons/lu';

import { TAgentMetadata } from '@/types/agents';
import { getFileName, handleDownload } from '@/utils/result';

type ImageOutputValue = string | { viewUrl?: string; downloadUrl?: string };

const getViewUrl = (value: ImageOutputValue): string | null => {
  if (!value) {return null;}
  if (typeof value === 'string') {
    return value;
  }

  return value.viewUrl ? String(value.viewUrl) : null;
};

const getDownloadUrl = (value: ImageOutputValue): string | null => {
  if (!value) {
    return null;
  }
  if (typeof value === 'string') {
    return value;
  }

  return value.downloadUrl ? String(value.downloadUrl) : (value.viewUrl ? String(value.viewUrl) : null);
};

const ImageOutput = ({
  metadata,
  isLoading,
  outputKey,
}: {
  metadata: TAgentMetadata | null;
  isLoading: boolean;
  outputKey: string;
}) => {
  const rawValue = metadata?.output?.[outputKey] as ImageOutputValue | undefined;
  const viewUrl = rawValue != null ? getViewUrl(rawValue) : null;
  const downloadUrl = rawValue != null ? getDownloadUrl(rawValue) : null;

  return (
    <Stack gap={4} w="100%">
      {viewUrl && !isLoading && (
        <Box borderRadius={4} p={3}>
          <Image src={viewUrl} alt="Output" />
        </Box>
      )}
      <HStack justify="space-between" alignSelf="flex-start">
        {!isLoading && downloadUrl && (
          <Button
            size="sm"
            variant="ghost"
            onClick={() => handleDownload(downloadUrl, getFileName(downloadUrl) || 'output.png')}
            color="purple.600"
            py="2px"
            px="8px"
          >
            <LuDownload />
            Download File
          </Button>
        )}
      </HStack>
    </Stack>
  );
};

export default ImageOutput;